// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"review_promotion_manager__2HRJ8","card":"review_card__3MvNs"};